import React from 'react';
import { graphql, Link } from 'gatsby';
import styled from 'styled-components';
import { pipe, path, map, filter } from 'ramda';

import Layout from '../components/Layout';
import Container from '../components/Container';
import Courses from '../components/Courses';

const StyledContainer = styled(Container)`
  margin-top: 6rem;
`;

const Post = styled.div`
  & + & {
    margin-top: 2rem;
  }
`;

const PostTitle = styled.h2`
  font-weight: 500;
  margin-bottom: 0.5em;
  font-family: Roboto, sans-serif;
  font-size: 1.3rem;
  line-height: 1.3;
`;

const PostDescription = styled.p`
  margin: 0;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin: 0 0 1rem;
`;

const IndexPage = ({ data }) => {
  const posts = pipe(
    path(['allMarkdownRemark', 'edges']),
    map(path(['node', 'frontmatter']))
  )(data);
  const postsWithoutCategory = filter(post => post.category === null, posts);
  return (
    <Layout>
      <Courses />
      <StyledContainer>
        <SectionTitle>Pozostałe posty</SectionTitle>
        {postsWithoutCategory.map(({ title, path, description }) => (
          <Post key={path}>
            <PostTitle>
              <Link to={path}>{title}</Link>
            </PostTitle>
            <PostDescription>{description}</PostDescription>
          </Post>
        ))}
      </StyledContainer>
    </Layout>
  );
};

export const pageQuery = graphql`
  {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      limit: 1000
    ) {
      edges {
        node {
          frontmatter {
            path
            title
            description
            category
          }
        }
      }
    }
  }
`;

export default IndexPage;
